import styled from '@emotion/styled';

const AssetsWrapper = styled.div`
  margin-top: 50px;
`;

export {
  AssetsWrapper
};
